import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'porZero'
})
export class FormateNumberZeroPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) { return ''; }
    const tratando = value.split(',');
    return (tratando[1].length === 1) ? (value + 0) : value;
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/pipe/format-number-zero.pipe.ts